import React from "react";
import "./title.css";
import { LinkedinLogo, GithubLogo, CaretDown } from "@phosphor-icons/react";
import rachelImg from "./rachel-img.png";

const Title = () => {
  const scrollToProjects = () => {
    document.getElementById('projects')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="title-container">
      <div className="home-content">
        <h1 className="title">Rachel Ma</h1>
        <h2 className="subtitle">data, designer, developer</h2>
        <div className="social-icons">
          <a
            href="https://www.linkedin.com/in/rachel-ma2"
            className="social-link"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn Profile"
          >
            <LinkedinLogo weight="regular" />
          </a>
          <a
            href="https://github.com/Ma-rachl"
            className="social-link"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="GitHub Profile"
          >
            <GithubLogo weight="regular" />
          </a>
        </div>
      </div>

      <div className="home-image">
        <img src={rachelImg} alt="Rachel Ma" />
      </div>

      <div className="scroll-hint" onClick={scrollToProjects} style={{ cursor: 'pointer' }}>
        <span>scroll</span>
        <CaretDown weight="bold" />
      </div>
    </div>
  );
};

export default Title;
